import { useDispatch } from "react-redux";
import { closePopup } from "../../App/Slices/popupSlice";
import "./Controls.scss";
export const Controls = () => {
  const dispatch = useDispatch();
  const handleClosePopup = () => {
    dispatch(closePopup(""));
  };

  const controls = [
    {
      name: "A",
      action: "Move Left",
    },
    {
      name: "D",
      action: "Move Right",
    },
    {
      name: "W",
      action: "Aim UP",
    },
    {
      name: "S",
      action: "Aim Down",
    },
    // {
    //   name: "Q",
    //   action: "Previous Weapon",
    // },
    // {
    //   name: "E",
    //   action: "Next Weapon",
    // },
    {
      name: "1-3",
      action: "Weapon Selection",
    },
    {
      name: "Enter",
      action: "Fire",
    },
    {
      name: "Space",
      action: "Jump",
    },
    {
      name: "Left click + Hold + Move",
      action: "Camera Movement",
    },
  ];

  return (
    <div className="GameControls">
      <h1>
        Gameplay Controls
        <span onClick={handleClosePopup}>
          <span className="material-symbols-outlined">close</span>
        </span>
      </h1>
      <h3>Key Mapping</h3>
      <div>
        <div>
          <span>Key</span>
          <span>Action</span>
        </div>
        {controls.map((control, i) => (
          <div key={"ctrl_" + i}>
            <span>{control.name} </span>
            <span>{control.action}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
